import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {WhatsNewContentService} from "../whats-new-content.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {IWhatsNewContents} from "../whats-new.model";
import {isNil} from "lodash-es";

@Component({
    selector: 'app-whats-new-display',
    templateUrl: './whats-new-display.component.html',
    styleUrls: ['./whats-new-display.component.scss'],
    standalone: false
})
export class WhatsNewDisplayComponent implements OnInit {
  contentFetched = false;
  contentFullyLoaded: boolean = false;
  currentContent: SafeResourceUrl;
  whatsNewContents: IWhatsNewContents;
  currentContentIndex: number;
  contentsMarkedAsSeen: string[] = [];


  constructor(private whatsNewService: WhatsNewContentService,
              private sanitizer: DomSanitizer,
              private changeDetector: ChangeDetectorRef,
  ) { }


  ngOnInit(): void {
    this.loadContents();
  }

  private loadContents(): void {
    this.whatsNewService.getLatestContent().subscribe((contents) => {
      this.contentFetched = true;
      this.whatsNewContents = contents;
      this.loadNextContent();
    });
  }

  loadNextContent() {
    const contents = this.whatsNewContents.contents;
    if (isNil(this.currentContentIndex)) {
      //load first content
      if (this.whatsNewContents.contents.length > 0) {
        this.currentContentIndex = 0;
        this.currentContent = this.sanitizer.bypassSecurityTrustResourceUrl(contents[0].url);
      } else {
        //info - no help content defined at the moment
      }
    } else {
      if (this.hasNextContent()) {
        this.currentContentIndex++;
        this.currentContent = this.sanitizer.bypassSecurityTrustResourceUrl(contents[this.currentContentIndex].url);
      } else {
        //error no content - no help content defined at the moment
      }
    }
  }


  hasNextContent() {
    const contents = this.whatsNewContents.contents;
    return !isNil(this.currentContentIndex) && this.currentContentIndex + 1 < contents.length
  }

  hasPreviousContent() {
    return this.currentContentIndex - 1 >= 0;
  }
  hasMultipleContents() {
    return this.whatsNewContents?.contents.length > 1;
  }

  loadPreviousContent() {
    const contents = this.whatsNewContents.contents;
    if (this.currentContentIndex - 1 >= 0) {
      this.currentContentIndex--;
      this.currentContent = this.sanitizer.bypassSecurityTrustResourceUrl(contents[this.currentContentIndex].url);
    } else {
      //error no content - no help content defined at the moment
    }
  }


  contentLoadedInIframe(event: any) {
    if(event.target.src) {    // as Angular loads iframe twice, one with src='' and another with the actual input url.
      this.contentFullyLoaded = true;
      const seenVersion = this.whatsNewContents.contents[this.currentContentIndex].version;

      //don't notify too many times
      if (this.contentsMarkedAsSeen.includes(seenVersion)) {
        //nothing marked as seen already
      } else {
        this.whatsNewService.recordContentSeen(seenVersion);
        this.contentsMarkedAsSeen.push(seenVersion);
      }
    }
  }
}
